import React from "react";
import { cardKey } from "../hooks/useLiveAssist";

// Presentational: shows the live cue cards surfaced by the Recall.ai bot. The
// session (start/stop) is owned by useLiveAssist() in <App /> and the Start/Stop
// control lives in the app header; this widget just renders what's live.
export default function LiveAssist({ started, startError, canStart, visibleCards, closeCard }) {
  return (
    <section className="widget-card">
      <h3 className="widget-title">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="2" />
          <path d="M4.93 19.07a10 10 0 0 1 0-14.14M7.76 16.24a6 6 0 0 1 0-8.49M16.24 7.76a6 6 0 0 1 0 8.49M19.07 4.93a10 10 0 0 1 0 14.14" />
        </svg>
        Live Assist
      </h3>

      {!canStart && (
        <div style={{ color: "var(--text-muted)", fontSize: "0.85rem", padding: "8px 0" }}>
          No Teams join link is available for this meeting yet, so the assistant
          bot can't join.
        </div>
      )}

      {startError && (
        <div style={{ color: "var(--danger)", fontSize: "0.85rem", padding: "8px 0" }}>
          Could not start the live assist bot.
        </div>
      )}

      {!started ? (
        <div style={{ color: "var(--text-muted)", fontSize: "0.85rem", padding: "8px 0" }}>
          Use <strong>Start live assist</strong> at the top to send the bot into
          the meeting. Cue cards will appear here as topics come up.
        </div>
      ) : (
        <>
          <div className="simulation-info">
            <div style={{ display: "flex", gap: "6px", alignItems: "flex-start" }}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                style={{ marginTop: "2px", flexShrink: 0 }}
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
              <div>
                <strong>Live cue cards:</strong> the bot listens to the meeting and
                surfaces your cue cards as topics come up.
              </div>
            </div>
          </div>

          <ul className="cuecards-list">
            {visibleCards.length === 0 && (
              <div className="no-cards-placeholder">
                Listening… cue cards will appear as they're mentioned.
              </div>
            )}

            {visibleCards.map((card) => (
              <li key={cardKey(card)} className="cuecard-item expanded">
                <div className="cuecard-header">
                  <span className="cuecard-question">{card.question}</span>
                  <button
                    type="button"
                    className="cuecard-close-btn"
                    aria-label="Close cue card"
                    title="Close (reappears if the keyword is mentioned again)"
                    onClick={() => closeCard(card)}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                </div>
                {card.answer && (
                  <div className="cuecard-body">
                    <div style={{ color: "var(--text-primary)" }}>
                      {card.answer}
                    </div>
                  </div>
                )}
                {card.tags && card.tags.length > 0 && (
                  <div className="cuecard-tags">
                    {card.tags.map((tag) => (
                      <span key={tag} className="tag-chip active-match">
                        #{tag}
                      </span>
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
